const data = [
  {
    id: 1,
    cover: "./assets/47.jpg",
    title: "Matka i żona Edypa, wdowa po Lajosie",
    category: "Jokasta",
  },
  {
    id: 2,
    cover: "./assets/40.jpg",
    title:
      "Król Teb - nieświadomie zabił ojca, ożenił się z matką, i spłodził czworo dzieci",
    category: "Edyp",
  },
  {
    id: 3,
    cover: "./assets/48.jpg",
    title: "Sfinks zadający pytania",
    category: "Wyrocznia",
  },
  {
    id: 4,
    cover: "./assets/45.jpg",
    title:
      "Zarówno za życia, jak i po śmierci był czczony przez współobywateli jako bohater",
    category: "Autor",
  },
  {
    id: 5,
    cover: "./assets/44.jpg",
    title: "Największy obok Ajschylosa i Eurypidesa tragik starożytnej Grecji",
    category: "Autor",
  },
  {
    id: 6,
    cover: "./assets/46.jpg",
    title: "Sofokles był także politykiem, dowódcą wojskowym i kapłanem",
    category: "Autor",
  },
];

export default data;
